import { Link, Outlet, useLocation, useRouteLoaderData, useSearchParams } from "react-router-dom";

import ServerFooter from "../common/ServerFooter";
import UserInfo from "src/components/common/userInfo";
import { useAuthStore, User } from "../main/authStore";

import { Proposal } from "./types";

export const extraFields = ["page", "limit"];

export default function ProposalList() {
    const [searchParams] = useSearchParams();
    const user = useAuthStore(state => state.user) as User;
    const location = useLocation();
    const {
        proposals,
        total,
    }: { proposals: Proposal[]; start?: string; end?: string; total: number } = useRouteLoaderData("Proposals")!;
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;

    return (
        <div className = "cssContent pb8rem">
            <nav className = "my-3">
                <Link className = "btn btn-outline-primary pointer position-relative" to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                    {onFilter ? <span className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{ minWidth: "2.2em" }}>on</span> : null}
                </Link>
                <Link className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}>
                    Export
                </Link>
                {user.projects !== "no" ? (
                    <Link className = "btn btn-outline-primary pointer ms-3" to = "Add">
                        Add
                    </Link>
                ) : null}
            </nav>
            {!proposals.length ? (
                <div className = "cssLoading">Empty</div>
            ) : (
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Proposal Number</th>
                                <th>Proposal Date</th>
                                <th>Requester</th>
                                <th>Project</th>
                                <th>Total</th>
                                <th>Approver</th>
                                <th>Status</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {proposals.map(proposal => (
                                <tr key = {proposal.id}>
                                    <td>{proposal.proposalNumber}</td>
                                    <td>{proposal.proposalDate}</td>
                                    <td><UserInfo name = {proposal.requesterName} id = {proposal.requesterId} /></td>
                                    <td>{proposal.projectId ? <Link to = {`/Projects/${proposal.projectId}`}>{proposal.projectName}</Link> : null}</td>
                                    <td>${proposal.total}</td>
                                    <td><UserInfo name = {proposal.approverName} id = {proposal.approverId} /></td>
                                    <td>{proposal.status}</td>
                                    <td><Link className = "btn btn-outline-primary" to = {String(proposal.id)}>Detail</Link></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {total ? <ServerFooter length = {total} /> : null}
            <Outlet />
        </div>
    );
}
